import React from "react"

import { LinkTag, Obj } from "scrivito"
import { IconSize } from "shared/types/Icon"
import { Icon } from "shared/ui/icon/Icon"
import { IconName } from "shared/ui/icon/__generated__/IconName"

interface ScrivitoBreadcrumbItemProps {
  obj: Obj | null
  ignoredObjClasses: string[]
}

export const ScrivitoPageBreadcrumbItem = React.memo(
  ({ obj, ignoredObjClasses }: ScrivitoBreadcrumbItemProps) => {
    if (!obj || ignoredObjClasses.includes(obj.objClass())) {
      return null
    }
    return (
      <li
        className="breadcrumb-item"
        data-testid="breadcrumb-item"
        key={obj.id()}
      >
        <LinkTag to={obj} className="link">
          {(obj.get("navigationTitle") || obj.get("title")) as string}
        </LinkTag>
        <Icon
          className="breadcrumb-item__separator"
          name={IconName.SMALL_CARET_RIGHT}
          size={IconSize.XXS}
        />
      </li>
    )
  }
)
